/* https://jquense.github.io/react-widgets/ */

import React, { Component } from 'react';

import UrdUnitFeatureItem from "./UrdUnitFeatureItem";


export default class UrdUnitFeatures extends Component {

    constructor(props) {
        super(props);

        this.getRowsData = this.getRowsData.bind(this);
    }

    getRowsData = function (features, rows) {
        return rows.map((row, index) => {
            return <tr><RenderRow extDisable={this.props.extDisable} handleUpdate={this.props.handleUpdate} updateConfiguration={this.props.updateConfiguration}
                configurationId={this.props.configurationId} urdId={this.props.urdId} unitId={this.props.unitId} unitNumber={this.props.unitNumber} features={features} key={index} columns={row.columns} handleLock={this.props.handleLock} showError={this.props.showError} /></tr>
        })
    }

    render() {
        //const debug = this.props.debug;
        const groups = this.props.groups;
        const features = this.props.features;

        return (
            <div className="features">
                {groups.map((group, index) => (
                    <div class="cdsFeatureItem">
                        <div class="cdsFeatureItemHeader">
                            {group.label}
                        </div>
                        {/* {this.getRowsData(features, group.lists.filter(list => { return list.row === 1 }))}*/}
                        <table>
                            <tbody>
                                {this.getRowsData(features, group.rows)}
                            </tbody>
                        </table>
                    </div>
                ))}
            </div>
        );
    }
}

const RenderRow = (props) => {
    return props.columns.map((key, index) => {
        if (key.idCDSParameter != null) {

            let f = props.features.find(feature => { return feature.id === key.idCDSParameter });
            if (f && (f.visible == undefined || f.visible == true)) {
                let difference = "";
                let differenceCDS = {};
                if (f.type == 'numericUpDown') {
                    if (f.difference != "" && f.difference != undefined) {
                        difference = f.difference;
                        differenceCDS = props.features.find(feature => { return feature.id === f.differenceCDSId });
                    }
                }
                return <td className="cdsCell" colSpan={key.columnSpan}><UrdUnitFeatureItem extDisable={props.extDisable} configurationId={props.configurationId}
                    urdId={props.urdId} unitId={props.unitId} unitNumber={props.unitNumber} autoSize={key.autoSize} feature={f}
                    handleUpdate={props.handleUpdate} updateConfiguration={props.updateConfiguration}
                    difference={difference} differenceDescription={differenceCDS.description}
                    handleLock={props.handleLock} showError={props.showError}
                /></td>
            }
            else if (f) {
                return <td className="cdsCell" colSpan={key.columnSpan}></td>
            }
            else {
                props.showError({ name: "Ошибка поиска значений", message: 'Не найдено значение по id ' + key.idCDSParameter });
                return <td className="cdsCell" colSpan={key.columnSpan}></td>
            }
        } else {
            return <td className="cdsCell" colSpan={key.columnSpan}></td>
        }
    })
}
